<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todas as inscrições na seleção. Toda nova
              inscrição aparecerá automaticamente na tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="card shadow table-container vld-parent" ref="calls_table">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    Inscrições na seleção
                    <span class="text-orange">{{ tableName }}</span>
                    <router-link
                      :to="`/admin/selecoes/${$route.params.id}/editar`"
                    >
                      <i class="ml-2 fas fa-eye fa-sm"></i>
                    </router-link>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Nome</th>
                  <th>Localização</th>
                  <th>Email</th>
                  <th>Telefone</th>
                  <th></th>
                </template>
                <template slot-scope="{ row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.city }}, {{ row.state }}</td>
                  <td>{{ row.email }}</td>
                  <td>
                    {{
                      row.phone
                        | VMask(
                          `(##) ####${row.phone.length > 8 ? "#" : ""}-####`
                        )
                    }}
                  </td>
                  <td>
                    <router-link
                      :to="
                        '/admin/selecoes/' +
                        $route.params.id +
                        '/inscricoes/' +
                        row.id
                      "
                      ><i
                        class="fas ml-2 fa-eye text-primary"
                        title="Visualizar inscrição"
                      ></i
                    ></router-link>
                    <span @click="handleOpenModalConfirmation(row.id, row.name)"
                      ><i
                        class="fas fa-trash ml-3 text-red cursor-pointer"
                        title="Deletar inscrição"
                      ></i
                    ></span>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há inscrições na seleção até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a inscrição de
            <span class="text-warning">{{ modals.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações preenchidas serão perdidas.
          </p>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveSubscription"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "chamadas_inscricoes_table",
  data() {
    return {
      tableName: "",
      tableData: [],
      empty: false,
      modals: {
        modalConfirmation: false,
        name: "",
        subscriptionId: null,
      },
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.calls_table,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get(
        `/adm/recruitment-processes/${this.$route.params.id}?subscriptions=true`
      );
      this.tableName = data.title;
      if (data.subscriptions.length) this.tableData = data.subscriptions;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as inscrições");
    }
  },
  methods: {
    handleOpenEvaluation() {
      this.$router.push(`/admin/selecoes/${this.$route.params.id}/avaliacao`);
    },
    handleOpenModalConfirmation(subscriptionId, name) {
      this.modals.subscriptionId = subscriptionId;
      this.modals.name = name;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.subscriptionId = null;
      this.modals.name = "";
    },
    async handleSubmitRemoveSubscription() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/adm/recruitment-processes/${this.$route.params.id}/subscriptions/${this.modals.subscriptionId}`
        );
        this.$toasted.show("Inscrição removida com sucesso");
        this.$router.go();
      } catch (e) {
        this.error = "Ocorreu um erro ao remover a inscrição";
        this.$toasted.error(this.error);
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
